<template>
  <tr>
    <td class="text-center"><v-checkbox v-model="entity.selected"></v-checkbox></td>
    <td v-for="field in levelZero" :key="field.name">
      <template v-if="Array.isArray(entity[field.name])">
        <span v-for="(value, v) in entity[field.name]" :key="v">
          {{ $t(value[field.primaryField]) }}
        </span>
      </template>
      <template v-else>
        <span v-if="field.name === 'created_at'">
          {{ $t(entity[field.name]) | moment('DD/MM/YYYY') }}
        </span>
        <span v-else>{{ $t(entity[field.name]) }}</span>
      </template>
    </td>
    <td v-for="field in levelOne" :key="field.name">
      {{ $t(entity[field.name]) }}
    </td>
    <td>
      <v-menu>
        <!--        <v-btn slot="activator" color="primary" dark flat min-width="100">-->
        <!--          {{ $t('Acciones') }}-->
        <!--        </v-btn>-->
        <v-btn slot="activator" color="primary" dark flat min-width="100" @click="deleteDocument()">
          {{ $t('Eliminar') }}
        </v-btn>
        <!--        <v-list>-->
        <!--          <v-list-tile @click="changeStatus('confirmed')">-->
        <!--            <v-list-tile-title>-->
        <!--              {{ $t('Confirmado') }}-->
        <!--            </v-list-tile-title>-->
        <!--          </v-list-tile>-->
        <!--          <v-list-tile @click="changeStatus('in_progress')">-->
        <!--            <v-list-tile-title>-->
        <!--              {{ $t('Sin confirmar') }}-->
        <!--            </v-list-tile-title>-->
        <!--          </v-list-tile>-->

        <!--          <v-list-tile @click="deleteDocument()">-->
        <!--            <v-list-tile-title>-->
        <!--              {{ $t('Eliminar') }}-->
        <!--            </v-list-tile-title>-->
        <!--          </v-list-tile>-->
        <!--        </v-list>-->
      </v-menu>
    </td>
  </tr>
</template>

<script>
import AruListItemMixin from '@/mixins/list/AruListItemMixin.js';
// import CalendarEventIconStatus from '@/components/commons/CalendarEventIconStatus.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';
// const moment = require('moment')
// require('moment/locale/es')
export default {
  mixins: [AruListItemMixin],
  props: {
    adminActions: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    // CalendarEventIconStatus,
  },
  methods: {
    getBadgeColor() {
      switch (this.entity.status) {
        case 'in_progress':
          return 'grey lighten-1';
        case 'confirmed':
          return 'primary';
        case 'error':
          return 'error';
        default:
          return 'grey lighten-1';
      }
    },
    editEntity() {
      console.log(this.entity);
    },
    changeStatus(status) {
      apiCtrl
        .post('/oficial-document/change-status/' + this.entity.id, {
          status: status,
        })
        .then(res => {
          console.log({
            DOCUEMTNE: res,
          });
          this.entity.status = status;
        });
    },
    deleteDocument() {
      let toDelete = this.entity;
      apiCtrl.delete('/consultant-document/' + this.entity.id).then(res => {
        console.log(res);
        this.$emit('entityDeleted', toDelete);
      }),
        console.log(this.entity);
    },
  },
};
</script>

<style></style>
